import { useGetSessionsAnalyticsActivityQuery } from '@carboncopyco/data';
import { ColorHex } from '@carboncopyco/ui';
import { useParams } from 'react-router-dom';
import { AnalyticsCard } from './AnalyticsCard';
import { useConsoleState } from './ConsoleContext';
import { useGetAnalyticsCardCommonData } from './useGetAnalyticsCardCommonData';

export const VisitsAnalyticsCard = () => {
  const { organizationId } = useParams();
  const { startTime, endTime, timezone } = useConsoleState();

  const {
    chart,
    trend,
    isLoading: isLoadingCommon,
  } = useGetAnalyticsCardCommonData({
    resourceTypes: ['shared_presentation', 'tour'],
  });
  const { data: sandboxVisitData, isLoading: isLoadingSandboxVisits } =
    useGetSessionsAnalyticsActivityQuery({
      organizationId,
      resourceTypes: ['shared_presentation'],
      start: startTime,
      end: endTime,
      timezone,
      resolution: 'summary',
      shortSessions: true,
      internalSessions: true,
    });

  const { data: tourVisitData, isLoading: isLoadingTourVisits } =
    useGetSessionsAnalyticsActivityQuery({
      organizationId,
      resourceTypes: ['tour'],
      start: startTime,
      end: endTime,
      timezone,
      resolution: 'summary',
      shortSessions: true,
      internalSessions: true,
    });

  const totalTourVisits = tourVisitData?.results?.[0]?.values?.occurrences || 0;
  const totalSandboxVisits =
    sandboxVisitData?.results?.[0]?.values?.occurrences || 0;
  const total =
    tourVisitData?.results && sandboxVisitData?.results
      ? totalTourVisits + totalSandboxVisits
      : null;
  const breakdownLabel = `${totalSandboxVisits} Sandbox visits | ${totalTourVisits} Tour visits`;
  const isLoading =
    isLoadingTourVisits || isLoadingSandboxVisits || isLoadingCommon;

  return (
    <AnalyticsCard
      isLoading={isLoading}
      title="Total visits"
      chartColor={ColorHex.accent1200}
      chart={chart}
      trend={trend}
      total={total}
      breakdown={breakdownLabel}
    />
  );
};
